import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { stopSpeaking } from "../lib/speech";

/**
 * Stops any in-progress SpeechSynthesis whenever the route changes.
 * Prevents TTS from "leaking" across pages.
 */
export default function RouteEffects() {
  const location = useLocation();
  useEffect(() => {
    stopSpeaking();
  }, [location.pathname]);
  useEffect(() => {
    const onHide = () => stopSpeaking();
    window.addEventListener("pagehide", onHide);
    window.addEventListener("beforeunload", onHide);
    return () => {
      window.removeEventListener("pagehide", onHide);
      window.removeEventListener("beforeunload", onHide);
      stopSpeaking();
    };
  }, []);
  return null;
}
